// patient-registration-center.resolver.ts
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Bundle } from 'fhir/r4';
import { ErrorService } from '../shared/error.service';
import { catchError, of } from 'rxjs';
import { backendEndPointToken } from '../app.config';

/**
 * Resolver: Fetch Patient registrations from the Elikita FHIR R4 server via the gateway
 * The gateway will handle forwarding to the actual FHIR server and apply org filters
 */
export const patRegResolver: ResolveFn<Bundle> | [] = (route, state) => {
  const http = inject(HttpClient);
  const errorService = inject(ErrorService);
  const backendApi = inject(backendEndPointToken);

  // ✅ Use the /fhir gateway endpoint (NOT the direct backend URL)
  // The gateway at /fhir will forward to the actual FHIR server
  // and apply organization filtering automatically
  
  // ✅ Only pass query params, let the gateway handle the base URL
  const gatewayUrl = `${backendApi}/Patient`;
  
  // ✅ Use HttpParams for proper query string construction
  const params = new URLSearchParams();
  params.append('active', 'true');      // Only active patients
  params.append('_count', '1000');
  params.append('_sort', '-_lastUpdated'); // Descending by last updated
  params.append('_format', 'json');

  // ✅ Construct URL properly
  const urlWithParams = `${gatewayUrl}?${params.toString()}`;

  console.log('📋 Fetching patients from:', urlWithParams);

  return http.get<Bundle>(urlWithParams).pipe(
    catchError(err => {
      console.error('❌ Failed to load patient registrations:', err);
      console.error('   Status:', err.status);
      console.error('   URL:', err.url);
      console.error('   Message:', err.message);
      
      errorService.openandCloseError('Failed to load patient registrations');
      
      // Return empty Bundle to prevent null errors
      return of({ 
        resourceType: 'Bundle', 
        type: 'searchset', 
        total: 0, 
        entry: [] 
      } as Bundle);
    })
  );
};